const common = require('angular').module('oly.common');

const maxlengthcounterDirectives = require('./maxlengthcounter.directive');

common.directive('olyShowMaxlengthCounter', [maxlengthcounterDirectives.showMaxlengthCounter]);



// WEBPACK FOOTER //
// ./src/olycommon/maxlengthcounter/index.js